import { Injectable } from "@angular/core";
import { ProgramInfoEndpointService } from "./programInfo-endpoint.service";

@Injectable()
export class ProgramInfoService {

    public programVersion: string;
    public programVersionShort: string;

    constructor(programmInfoEndPointService: ProgramInfoEndpointService) {
        programmInfoEndPointService.getVersion().subscribe(result => {
            this.programVersion = result;
            let programmVersionArray: string[] = this.programVersion.split("-");
            if (programmVersionArray.length > 2) {
                this.programVersionShort = programmVersionArray[0] + programmVersionArray[1];
            }
        });
    }

}
